import React, { useState, useEffect } from 'react';

const PaymentPage: React.FC = () => {
  const [selectedTier, setSelectedTier] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    companyName: '',
    cardNumber: '',
    expiryDate: '',
    cvv: '',
    billingAddress: ''
  });

  useEffect(() => {
    const tier = localStorage.getItem('selectedTier') || 'Free';
    setSelectedTier(tier);
  }, []);

  const getTierPrice = (tier: string) => {
    switch (tier) {
      case 'Standard': return '$49';
      case 'Enterprise': return '$99';
      default: return '$0';
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handlePayment = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    setTimeout(() => {
      localStorage.setItem('subscriptionActive', 'true');
      localStorage.setItem('userEmail', formData.email);
      localStorage.setItem('companyName', formData.companyName);
      window.location.href = '/thank-you';
    }, 2000);
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', padding: '40px 0' }}>
      <div className="container">
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <div className="card">
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
              <h2 style={{ color: '#2c3e50', marginBottom: '10px' }}>Complete Your Subscription</h2>
              <p style={{ color: '#6c757d' }}>You selected the <strong>{selectedTier}</strong> plan</p>
              <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#007bff', marginTop: '10px' }}>
                {getTierPrice(selectedTier)}/month
              </div>
            </div>

            <form onSubmit={handlePayment}>
              <div className="form-group">
                <label>Email Address *</label>
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required 
                  placeholder="your@email.com"
                />
              </div>

              <div className="form-group">
                <label>Company Name *</label>
                <input 
                  type="text" 
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleInputChange}
                  required 
                  placeholder="Your HVAC Company"
                />
              </div>

              {selectedTier !== 'Free' && (
                <>
                  <div className="form-group">
                    <label>Card Number *</label>
                    <input 
                      type="text" 
                      name="cardNumber"
                      value={formData.cardNumber}
                      onChange={handleInputChange}
                      required 
                      placeholder="1234 5678 9012 3456"
                      maxLength={19}
                    />
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                    <div className="form-group">
                      <label>Expiry Date *</label>
                      <input 
                        type="text" 
                        name="expiryDate"
                        value={formData.expiryDate}
                        onChange={handleInputChange}
                        required 
                        placeholder="MM/YY"
                        maxLength={5}
                      />
                    </div>
                    <div className="form-group">
                      <label>CVV *</label>
                      <input 
                        type="text" 
                        name="cvv"
                        value={formData.cvv}
                        onChange={handleInputChange}
                        required 
                        placeholder="123"
                        maxLength={4}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Billing Address *</label>
                    <input 
                      type="text" 
                      name="billingAddress"
                      value={formData.billingAddress}
                      onChange={handleInputChange}
                      required 
                      placeholder="123 Main St, City, State, ZIP"
                    />
                  </div>
                </>
              )}

              <div style={{ marginTop: '30px' }}>
                <button 
                  type="submit" 
                  className="btn btn-primary" 
                  style={{ width: '100%', padding: '15px' }}
                  disabled={loading}
                >
                  {loading ? 'Processing...' : selectedTier === 'Free' ? 'Create Free Account' : 'Complete Payment'}
                </button>
              </div>
            </form>

            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <button 
                className="btn btn-secondary"
                onClick={() => window.location.href = '/'}
                style={{ textDecoration: 'none' }}
              >
                Back to Pricing
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;